import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/admin/circle-exclamation-warning.svg")